import React from 'react';

import { IconEnvelope, IconHandshake, IconCalendar, IconPager, IconShieldHalved } from '../components/ui-kit/icons.js';

const link = {
  cursor: 'pointer'
};

export const UserContractButton = ({ user }) => {
  const url = `/users/${user.id}/reporting/contracts/contracts`;

  return (
    <span title={I18n.t('users.contracts_for', { name: user.nickname })}>
      <a href={url} target="_blank" rel="noreferrer">
        <IconHandshake style={link} />
      </a>
    </span>
  );
};

export const SendMessageButton = ({ user }) => {
  const url = `/users/current/communication/sent_messages/new?recipients%5B%5D=user_${user.id}`;
  return (
    <span title={I18n.t('send_message')}>
      <a href={url} target="_blank" rel="noreferrer">
        <IconEnvelope icon="envelope" style={link} />
      </a>
    </span>
  );
};

export const ScheduleButton = ({ membership, user }) => {
  if (!membership?.id) return null;

  const url = `/memberships/${membership?.id}/schedule/personal_calendar`;
  return (
    <span title={I18n.t('schedules.personal.exceptions.show_for', { name: user.nickname })}>
      <a href={url} target="_blank" rel="noreferrer">
        <IconCalendar style={link} />
      </a>
    </span>
  );
};

export const LoginAsButton = ({ user }) => {
  const url = `/admin/users/${user.id}/become`;
  return (
    <span>
      <a href={url} target="_blank" rel="noreferrer">
        <IconShieldHalved style={link} />
      </a>
    </span>
  );
};

export const UserPagersButton = ({ user }) => {
  const url = `/users/${user.id}/pagers`;
  return (
    <span>
      <a href={url} target="_blank" rel="noreferrer">
        <IconPager style={link} />
      </a>
    </span>
  );
};

export default {
  UserContractButton,
  SendMessageButton,
  ScheduleButton,
  LoginAsButton,
  UserPagersButton
};
